const Accordion = {
  baseStyle: {
    button: {
      padding: 4,
      backgroundColor: '#F0F0F0',
      _focus: {ring: 'none'},
    },
  },
}

export default Accordion
